/**
 * Type definitions for Market Map Polygons
 * Polygons allow users to draw and style parcel outlines on the market map
 */

export interface MapPolygon {
  polygonId: string;
  surveyId: string;
  name?: string;
  showLabel?: boolean;
  showBorder?: boolean;
  coordinates: number[][][]; // GeoJSON Polygon coordinates format
  style: PolygonStyle;
  isHidden: boolean;
  order: number;
  createdOn?: string;
  updatedOn?: string;
  createdBy?: string;
  updatedBy?: string;
}

export interface PolygonStyle {
  fillColor: string;
  fillOpacity: number;
  strokeColor: string;
  strokeWidth: number;
  strokeOpacity: number;
}

export const DEFAULT_POLYGON_STYLE: PolygonStyle = {
  fillColor: "#3b82f6", // Blue
  fillOpacity: 0.3,
  strokeColor: "#1e40af", // Darker blue
  strokeWidth: 2,
  strokeOpacity: 1,
};

// Predefined color options for quick selection
export const POLYGON_COLOR_PRESETS = [
  { name: "Blue", fillColor: "#3b82f6", strokeColor: "#1e40af" },
  { name: "Green", fillColor: "#10b981", strokeColor: "#047857" },
  { name: "Teal", fillColor: "#14b8a6", strokeColor: "#0f766e" },
  { name: "Pink", fillColor: "#ec4899", strokeColor: "#be185d" },
  { name: "Purple", fillColor: "#8b5cf6", strokeColor: "#6d28d9" },
  { name: "Orange", fillColor: "#f97316", strokeColor: "#c2410c" },
  { name: "Red", fillColor: "#ef4444", strokeColor: "#b91c1c" },
  { name: "Yellow", fillColor: "#eab308", strokeColor: "#a16207" },
];
